/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useState } from 'react';
import { Dialog, DialogContent, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import '../../styles.css';
import { LanguageContext } from '../../../../libs/Context';
import { RecognisedBackGround } from '../RecognitionBackground';
import { useCloseCongratsPopupMutation } from '../../Queries/RecogniseQuery';
import { useSelector } from 'react-redux';
import { queryParams } from '../../../../libs/HelperContent';
import { LoginContext } from '../../../../App';
import ProfilePic from '../../../../components/Common/ProfilePic';
const OneTimeRecognisationPopUp = (props) =>
{
	const { language } = useContext(LanguageContext);
	const { congratsPopUp, setCongratsPopUp } = props;
	const [ index, setIndex ] = useState(0);
	const [ closeCongrats ] = useCloseCongratsPopupMutation();
	const userData = useSelector((state:any) => state?.mysession?.session);
	const queryParamRes = queryParams(userData?.userId, userData?.companyId, userData?.empRole, userData?.role, 'cud');
	const { socket } = useContext(LoginContext);

	const closePopUp = async () =>
	{
		const query = `${queryParamRes}`;
		const body:any = {
			eventId : congratsPopUp?.map((each:any) => each?.eventId),
			status  : true
		};

		try
		{
			setCongratsPopUp([]);
			await closeCongrats({ query, body });

			const socketBody = {
				type   : 'on_close_recognition',
				userId : userData?.userId
			};

			socket && socket.emit('on_updates', socketBody);
		}
		catch (error)
		{
			console.log('Error', error);
		}
	};

	const handleBack = () =>
	{
		setIndex(index - 1);
	};

	const handleNext = () =>
	{
		setIndex(index + 1);
	};

	return (
		<div className='flexCol'>
			<Dialog
				open={props.open}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
				maxWidth='sm'
				PaperProps={{ style: { maxWidth: '640px' } }}
				fullWidth
			>
				<div className='flexRow alignCntr justifyCntr  pdngXS'>
					<div className='flexMinWidthCol alignCntr justifyCntr'>
						<span className='mainHdngTxt pdngBXXS'>
							{language?.congo} !
						</span>
					</div>
					<button
						tabIndex={0}
						onKeyUp={(e) => { e.key === 'Enter' && closePopUp(); }}
						aria-label='close popup'
						className='flexAutoRow' onClick={closePopUp}
					>
						<span className='lightxt pointer'>
							<Tooltip title={language.close}>
								<CloseIcon fontSize='small' />
							</Tooltip>
						</span>
					</button>
				</div>
				<DialogContent style={{ paddingTop: '0' }}>
					<div className='flexCol positionRelative fullHeight'>
						{congratsPopUp?.length > 0 && index > 0 && (
							<button
								tabIndex={0}
								onKeyUp={(e) => { e.key === 'Enter' && handleBack(); }}
								aria-label='back'
								className='prevArrowOneBtn pointer' onClick={handleBack}
							>
								❮
							</button>
						)}
						<div className='flexRow positionRelative recOnePopup'>
							<img
								src='/images/Recognizbadge/congratulation.gif'
								alt='gif'
								className='recognizCardWorkBg imgUploadZIndex'
							/>
							{congratsPopUp?.length > 0 && (
								<div className='flexCol' key={congratsPopUp[index].employeeData.userId}>
									<img
										src={
											RecognisedBackGround(
												'square',
												congratsPopUp[index].templateId,
												congratsPopUp[index].badgeId
											)?.background
										}
										alt='temp'
										loading='lazy'
										className={`recognizAnimatioBg ${congratsPopUp[index]?.templateId === 'T1' ? 'recBg1' : congratsPopUp[index]?.templateId === 'T2' ? 'recBg2' : 'recBg3'}`}
									/>
									<div className='flexCol  zindex fullHeight cardTextCntr pdngSM'>
										<div className='flexCol fullHeight respdngHXXS positionRelative'>
											<div className='flexMinHeightCol alignCntr justifyCntr positionRelative'>
												<div className='RecbadgeImg positionRelative'>
													<img src={
														RecognisedBackGround(
															'square',
															congratsPopUp[index].templateId,
															congratsPopUp[index].badgeId
														)?.badge
													}alt='recognisesqaure'
													/>
													<div className='recAvtharImg'>
														<ProfilePic
															imagePath={`${congratsPopUp[index].employeeData.userId}.jpeg?t=${new Date().valueOf()}`}
															defaultImg='/images/icons/defaultUser.svg'
															alt='profilepic'
															className='brdrRadius50'
															from='selfProfile'
														/>
													</div>
												</div>
												<div className='flexCol'>
													<div className='flexRow pdngTXS pdngBSM alignCntr justifyCntr'>
														<span className='recDarktGold recognizCardHeadding ellipsisTxt capitalTxt textCntr '>
															{congratsPopUp[index]?.employeeData?.name}
														</span>
													</div>
													<div className='flexRow alignCntr justifyCntr pdngVXXS'>
														<h3 className='recDarktGold recognizoneHeadding textCntr firstLetter mrgnBXXS'>
															{congratsPopUp[index]?.title}
														</h3>
													</div>
													<div className='flexRow alignCntr justifyCntr'>
														<span className='recDarktGold textCntr firstLetter recOneSubHed'>
															{congratsPopUp[index]?.description}
														</span>
													</div>
												</div>

											</div>
											<div className='flexAutoRow recBrdTop alignBaseline pdngVSM'>
												<div className='flexMinWidthCol'>
													<span className='recLightGold firstLetter pdngTXS reconeDateTxt'>
														{language.recognizedBy}
													</span>
													<span className='pdngVXXS recDarktGold recOneSubHed capitalTxt'>
														{congratsPopUp[index]?.companyDetail?.name}
													</span>
												</div>
												<div className='flexAutoRow'>
													<span className='recLightGold reconeDateTxt pdngTXXS '>
														{new Date(
															congratsPopUp[index].updatedAt
														).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							)}
						</div>
						{congratsPopUp?.length > 1 && index < congratsPopUp?.length - 1 && (
							<button
								tabIndex={0}
								onKeyUp={(e) => { e.key === 'Enter' && handleNext(); }}
								aria-label='next'
								className='nextArrowOneBtn' onClick={handleNext}
							>
								❯
							</button>
						)}
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
};

export default OneTimeRecognisationPopUp;
